import tippy from "tippy.js";



export default function () {
	return tippy('[data-tippy-content]',{
		trigger: 'click',          
    interactive: true,        
    hideOnClick: true,       
    appendTo: () => document.body
	});
}